import {Box, DialogProps, DialogTitle, Tab, Tabs} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'tolgee';

import {ClosableDialog} from '~components/common/ClosableDialog';
import {ABOVE_ASK_AI_PANEL_Z_INDEX} from '~components/ask-ai/askAiAgents';
import {AccountTab} from './AccountTab';
import {PersonalTab} from './PersonalTab';
import {SecurityTab} from './SecurityTab';

export interface UserSettingsProps extends Omit<DialogProps, 'title'> {
  open: boolean;
  onClose?: () => void;
}

export function UserSettings({open, onClose, ...rest}: UserSettingsProps) {
  const {t} = useTranslation('user');
  const [activeTab, setActiveTab] = useState('account');

  const handleChange = (_event: React.SyntheticEvent, tabName: string) => {
    setActiveTab(tabName);
  };

  return (
    <ClosableDialog
      fixedToTop
      hasTabs
      hasCloseButton
      open={open}
      onClose={onClose}
      sx={{zIndex: ABOVE_ASK_AI_PANEL_Z_INDEX}}
      data-testid='user-settings-dialog'
      {...rest}
    >
      <DialogTitle sx={{paddingBottom: 1}}>{t('settings')}</DialogTitle>
      <Box sx={{bgcolor: 'background.paper', width: 450}}>
        <Tabs sx={{paddingX: 3}} value={activeTab} onChange={handleChange}>
          <Tab value='account' label={t('account')} id='user-settings-account' />
          <Tab value='personal' label={t('personal')} id='user-settings-personal' />
          <Tab value='security' label={t('security')} id='user-settings-security' />
        </Tabs>
        <Box sx={{paddingX: 3, paddingBottom: 2}}>
          {activeTab === 'account' && <AccountTab />}
          {activeTab === 'personal' && <PersonalTab />}
          {activeTab === 'security' && <SecurityTab />}
        </Box>
      </Box>
    </ClosableDialog>
  );
}
